module.exports = {
    server_ip:"https://demoapiformoviedb.herokuapp.com",
    //server_ip:"http://192.168.43.243:5000",
    imgServer_ip:"https://storage.googleapis.com/demoimgstorage",
    frontWebServer_ip:"https://gifted-wiles-b9b018.netlify.app"
}